export default "__VITE_ASSET__67a931a8__"